"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  EmptyMarkup: () => EmptyMarkup,
  areEqualJson: () => areEqualJson,
  areEqualMarkups: () => areEqualMarkups,
  equalMarks: () => equalMarks,
  hashAttrs: () => hashAttrs,
  isEmptyMarkup: () => isEmptyMarkup,
  isEmptyNode: () => isEmptyNode,
  isFileId: () => isFileId,
  jsonToMarkup: () => jsonToMarkup,
  markupToJSON: () => markupToJSON,
  markupToText: () => markupToText,
  stripHash: () => stripHash,
  stripTags: () => stripTags
});
module.exports = __toCommonJS(utils_exports);
var import_fast_equals = require("fast-equals");
var import_hash_it = __toESM(require("hash-it"));
var import_dsl = require("./dsl");
var import_model = require("./model");
var import_traverse = require("./traverse");
const EmptyMarkup = jsonToMarkup((0, import_model.emptyMarkupNode)());
function isFileId(value) {
  return typeof value === "string" && value !== "";
}
__name(isFileId, "isFileId");
function isEmptyMarkup(markup) {
  if (markup === void 0 || markup === null || markup === "") {
    return true;
  }
  return isEmptyNode(markupToJSON(markup));
}
__name(isEmptyMarkup, "isEmptyMarkup");
function areEqualMarkups(markup1, markup2) {
  if (markup1 === markup2) {
    return true;
  }
  const node1 = markupToJSON(markup1);
  const node2 = markupToJSON(markup2);
  if (isEmptyNode(node1) && isEmptyNode(node2)) {
    return true;
  }
  return equalNodes(node1, node2);
}
__name(areEqualMarkups, "areEqualMarkups");
function areEqualJson(json1, json2) {
  return equalNodes(json1, json2);
}
__name(areEqualJson, "areEqualJson");
function equalNodes(node1, node2) {
  if (node1.type !== node2.type) return false;
  const text1 = node1.text ?? "";
  const text2 = node2.text ?? "";
  if (text1 !== text2) return false;
  if (!equalArrays(node1.content, node2.content, equalNodes)) return false;
  if (!equalArrays(node1.marks, node2.marks, equalMarks)) return false;
  if (!equalRecords(node1.attrs, node2.attrs)) return false;
  return true;
}
__name(equalNodes, "equalNodes");
function equalArrays(a, b, equal) {
  if (a === b) return true;
  const arr1 = a ?? [];
  const arr2 = b ?? [];
  if (arr1.length !== arr2.length) return false;
  return arr1.every((item1, i) => equal(item1, arr2[i]));
}
__name(equalArrays, "equalArrays");
function equalRecords(a, b) {
  if (a === b) return true;
  a = Object.fromEntries(Object.entries(a ?? {}).filter(([_, v]) => v != null));
  b = Object.fromEntries(Object.entries(b ?? {}).filter(([_, v]) => v != null));
  return (0, import_fast_equals.deepEqual)(a, b);
}
__name(equalRecords, "equalRecords");
function equalMarks(a, b) {
  return a.type === b.type && equalRecords(a.attrs, b.attrs);
}
__name(equalMarks, "equalMarks");
const emptyNodes = [import_model.MarkupNodeType.hard_break];
const nonEmptyNodes = [
  import_model.MarkupNodeType.horizontal_rule,
  import_model.MarkupNodeType.image,
  import_model.MarkupNodeType.reference,
  import_model.MarkupNodeType.emoji,
  import_model.MarkupNodeType.gif,
  import_model.MarkupNodeType.subLink,
  import_model.MarkupNodeType.table
];
function isEmptyNode(node) {
  if (emptyNodes.includes(node.type)) return true;
  if (nonEmptyNodes.includes(node.type)) return false;
  if (node.text !== void 0 && node.text?.trim().length > 0) return false;
  const content = node.content ?? [];
  return content.every(isEmptyNode);
}
__name(isEmptyNode, "isEmptyNode");
function jsonToMarkup(json) {
  return JSON.stringify(json);
}
__name(jsonToMarkup, "jsonToMarkup");
function markupToJSON(markup) {
  if (markup == null || markup === "") {
    return (0, import_model.emptyMarkupNode)();
  }
  try {
    if (markup.startsWith("{")) {
      const json = JSON.parse(markup);
      (0, import_traverse.traverseAllMarks)(json, (node, mark) => {
        mark.type = stripHash(mark.type);
      });
      return json;
    } else {
      return (0, import_dsl.nodeDoc)((0, import_dsl.nodeParagraph)((0, import_dsl.nodeText)(markup)));
    }
  } catch (error) {
    return (0, import_model.emptyMarkupNode)();
  }
}
__name(markupToJSON, "markupToJSON");
const ELLIPSIS_CHAR = "\u2026";
const WHITESPACE = " ";
function stripTags(markup, textLimit = 0) {
  const parsed = markupToJSON(markup);
  const textParts = [];
  let charCount = 0;
  let isHardStop = false;
  const pushText = /* @__PURE__ */ __name((text) => {
    if (textLimit > 0 && charCount + text.length > textLimit) {
      const toAddCount = textLimit - charCount;
      const textPart = text.substring(0, toAddCount);
      textParts.push(textPart);
      textParts.push(ELLIPSIS_CHAR);
      isHardStop = true;
    } else {
      textParts.push(text);
      charCount += text.length;
    }
  }, "pushText");
  (0, import_traverse.traverseNode)(parsed, (node, parent) => {
    if (isHardStop) {
      return false;
    }
    if (node.type === import_model.MarkupNodeType.text) {
      const text = node.text ?? "";
      pushText(text);
      return false;
    } else if (node.type === import_model.MarkupNodeType.paragraph || node.type === import_model.MarkupNodeType.table || node.type === import_model.MarkupNodeType.doc || node.type === import_model.MarkupNodeType.blockquote || node.type === import_model.MarkupNodeType.callout) {
      if (textParts.length > 0 && textParts[textParts.length - 1] !== WHITESPACE) {
        textParts.push(WHITESPACE);
        charCount++;
      }
    } else if (node.type === import_model.MarkupNodeType.reference) {
      const label = `${node.attrs?.label ?? ""}`;
      pushText(label.length > 0 ? `@${label}` : "");
    }
    return true;
  });
  const result = textParts.join("");
  return result;
}
__name(stripTags, "stripTags");
function markupToText(markup) {
  const jsonModel = markupToJSON(markup);
  const fragments = [];
  (0, import_traverse.traverseNode)(jsonModel, (node) => {
    if (node.type === import_model.MarkupNodeType.text) {
      const text = node.text ?? "";
      if (node.text !== void 0 && node.text.length > 0) {
        fragments.push(text);
      }
    } else if (node.type === import_model.MarkupNodeType.paragraph) {
      fragments.push("\n\n");
    }
    return true;
  });
  return fragments.join("").trim();
}
__name(markupToText, "markupToText");
const hashedMarkNameRegex = /(.*)(--[a-zA-Z0-9+/=]{8})$/;
function stripHash(attrName) {
  return hashedMarkNameRegex.exec(attrName)?.[1] ?? attrName;
}
__name(stripHash, "stripHash");
function hashAttrs(attrs) {
  const hash = (0, import_hash_it.default)(attrs);
  return (hash >>> 0).toString(16).padStart(8, "0");
}
__name(hashAttrs, "hashAttrs");
//# sourceMappingURL=utils.js.map
